// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductCollectionRealTimeInventory } from "@guestsupply/App/Services/ProductServiceV2";
import { Handler, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { GetProductCollectionRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSettingsCollection, getShouldLoadInventory } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";


type Parameter = GetProductCollectionRealTimeInventoryApiV2Parameter &
    HasOnSuccess<RealTimeInventoryModel> &
    HasOnError<unknown>;

type Props = {
    apiParameter: GetProductCollectionRealTimeInventoryApiV2Parameter;
    apiResult: RealTimeInventoryModel;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

// XNG-CHANGES-GSS-480 : pass performRealTimeInventory property and update getProductCollectionRealTimeInventory import
export const XngRequestDataFromApi: HandlerType = async props => {
    const state = props.getState();

    const { productSettings, websiteSettings } = getSettingsCollection(state);
    if (!productSettings.showInventoryAvailability) {
        return;
    }

    if (!getShouldLoadInventory(state)) {
        props.dispatch({ type: "Context/AddDeferredApiCall", deferredCallType: "inventory" });
        return false;
    }

    const isCartPage = getCurrentPage(state).type === "CartPage";
    const { isGuest } = state.context.session;
    const performRealTimeInventory = isGuest || isCartPage;
    try {
        props.apiResult = await getProductCollectionRealTimeInventory({
            ...props.apiParameter,
            properties: {
                performRealTimeInventory,
            },
        });
    } catch (error) {
        logger.warn(`Failed to load inventory data: ${error}`);
        props.error = error;
    }
};
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
